import { getGcsAccessToken, getGcsBucket } from './gcsAuth';

const getPublicUrl = (bucket, objectPath) =>
  `https://storage.googleapis.com/${bucket}/${objectPath}`;

const parseGcsError = async (response) => {
  try {
    const data = await response.json();
    return data.error?.message || response.statusText;
  } catch {
    return response.statusText;
  }
};

const parseObjectPath = (imageUrl, bucket) => {
  if (!imageUrl) return null;

  const escapedBucket = bucket.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const gcsMatch = imageUrl.match(
    new RegExp(`https://storage\\.googleapis\\.com/${escapedBucket}/(.+)$`)
  );
  if (gcsMatch) {
    return decodeURIComponent(gcsMatch[1]);
  }

  if (imageUrl.includes('firebasestorage.googleapis.com')) {
    try {
      return decodeURIComponent(imageUrl.split('/o/')[1].split('?')[0]);
    } catch {
      return null;
    }
  }

  return null;
};

export const uploadVehicleImage = async (file, vehicleId) => {
  const bucket = getGcsBucket();
  const extension = file.name.split('.').pop();
  const filename = `main_${Date.now()}.${extension}`;
  const objectPath = `vehicles/${vehicleId}/${filename}`;
  const contentType = file.type || 'application/octet-stream';
  const token = await getGcsAccessToken();

  const uploadUrl =
    `https://storage.googleapis.com/upload/storage/v1/b/${encodeURIComponent(bucket)}/o` +
    `?uploadType=media&name=${encodeURIComponent(objectPath)}`;

  const response = await fetch(uploadUrl, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': contentType,
    },
    body: file,
  });

  if (!response.ok) {
    const detail = await parseGcsError(response);
    throw new Error(`Failed to upload image to Google Cloud Storage: ${detail}`);
  }

  return getPublicUrl(bucket, objectPath);
};

export const deleteVehicleImage = async (imageUrl) => {
  if (!imageUrl) return;

  const bucket = getGcsBucket();
  const objectPath = parseObjectPath(imageUrl, bucket);
  if (!objectPath) return;

  try {
    const token = await getGcsAccessToken();
    const deleteUrl =
      `https://storage.googleapis.com/storage/v1/b/${encodeURIComponent(bucket)}/o/` +
      `${encodeURIComponent(objectPath)}`;

    await fetch(deleteUrl, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch {
    // Image may already be deleted
  }
};
